import React, { Component } from 'react';

class EditGraph extends Component {

    render() {

        return (
            <>        
                <h1>EditGraph</h1>
            </>
        )
    }
}

export default EditGraph;